import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getFilmById } from '../services/api';
import { Container, Card, Row, Col, Spinner, Alert, Button, Tab, Nav } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

const FilmDetail = () => {
  const [film, setFilm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('scheda');
  const { id } = useParams();
  const location = useLocation();
  const backTo = location.state?.from || '/film';
  const tornaIndietro = useTornaIndietro('/film');
  const isMobile = useMediaQuery({ maxWidth: 991 });

  // Mapping genere -> file immagine
  const getGenreImagePath = (genere) => {
    if (!genere) return null;
    
    const genreMapping = {
      'Azione': 'Azione Avventura.png',
      'Azione Avventura': 'Azione Avventura.png',
      'Avventura': 'Azione Avventura.png',
      'Animazione': 'Animazione.png',
      'Anime': 'Anime.png',
      'Commedia': 'Comico Commedia.png',
      'Comico': 'Comico Commedia.png',
      'Comico Commedia': 'Comico Commedia.png',
      'Documentario': 'Documentario.png',
      'Drammatico': 'Drammatico.png',
      'Dramma': 'Drammatico.png',
      'Erotico': 'Erotico.png',
      'Family': 'Family.png',
      'Fantascienza': 'Fantascienza.png',
      'Fantasy': 'Fantastico.png',
      'Fantastico': 'Fantastico.png',
      'Thriller': 'Giallo Thriller.png',
      'Giallo': 'Giallo Thriller.png',
      'Giallo Thriller': 'Giallo Thriller.png',
      'Guerra': 'Guerra.png',
      'Horror': 'Horror.png',
      'Musical': 'Musical.png',
      'Serie TV': 'Serie TV.png',
      'Serie Tv': 'Serie TV.png',
      'Teatro': 'Teatro.png',
      'Western': 'Western.png',
    };
    
    // Prova prima la corrispondenza esatta
    let fileName = genreMapping[genere];
    
    // Se non trova, cerca per parole chiave
    if (!fileName) {
      const genreLower = genere.toLowerCase();
      if (genreLower.includes('azione') || genreLower.includes('avventura')) {
        fileName = 'Azione Avventura.png';
      } else if (genreLower.includes('anime')) {
        fileName = 'Anime.png';
      } else if (genreLower.includes('animazione')) {
        fileName = 'Animazione.png';
      } else if (genreLower.includes('commedia') || genreLower.includes('comico')) {
        fileName = 'Comico Commedia.png';
      } else if (genreLower.includes('documentario')) {
        fileName = 'Documentario.png';
      } else if (genreLower.includes('dramma')) {
        fileName = 'Drammatico.png';
      } else if (genreLower.includes('erotico')) {
        fileName = 'Erotico.png';
      } else if (genreLower.includes('family')) {
        fileName = 'Family.png';
      } else if (genreLower.includes('fantascienza')) {
        fileName = 'Fantascienza.png';
      } else if (genreLower.includes('fantasy') || genreLower.includes('fantastico')) {
        fileName = 'Fantastico.png';
      } else if (genreLower.includes('thriller') || genreLower.includes('giallo')) {
        fileName = 'Giallo Thriller.png';
      } else if (genreLower.includes('guerra')) {
        fileName = 'Guerra.png';
      } else if (genreLower.includes('horror')) {
        fileName = 'Horror.png';
      } else if (genreLower.includes('musical')) {
        fileName = 'Musical.png';
      } else if (genreLower.includes('serie')) {
        fileName = 'Serie TV.png';
      } else if (genreLower.includes('teatro')) {
        fileName = 'Teatro.png';
      } else if (genreLower.includes('western')) {
        fileName = 'Western.png';
      }
    }
    
    return fileName ? `/genre_images/${fileName}` : null;
  };

  useEffect(() => {
    const fetchFilmData = async () => {
      try {
        setLoading(true);
        const response = await getFilmById(id);
        setFilm(response.data);
      
      } catch (err) {
        setError('Errore nel caricamento del film.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchFilmData();
  }, [id]);

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!film) return <Alert variant="warning">Film non trovato.</Alert>;

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Dettaglio Film: {film.titolo}</h2>
        <div>
          <Button variant="secondary" onClick={tornaIndietro} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" as={Link} to={'/film/edit/' + id} className="me-2">Modifica</Button>
          <Button variant="info" as={Link} to={'/film/print/' + id}>Stampa</Button>
        </div>
      </div>

      {/* ANTEPRIMA IMMAGINE */}
      {film.immagine_url && (
        <Card className="mb-4">
            <Card.Body className="text-center">
                <img 
                    src={process.env.REACT_APP_STATIC_FILES_BASE_URL + film.immagine_url} 
                    alt={"Copertina di " + film.titolo} 
                    style={{ maxHeight: '300px', border: '1px solid #dee2e6' }} 
                />
            </Card.Body>
        </Card>
      )}

      {/* TAB NAVIGATION */}
      <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
        <Card>
          <Card.Header className={isMobile ? "bg-light p-2" : "bg-light"}>
            <Nav variant="tabs" className={isMobile ? "card-header-tabs flex-column" : "card-header-tabs"}>
              <Nav.Item>
                <Nav.Link eventKey="scheda" className={isMobile ? "py-2 px-3" : "d-flex align-items-center gap-2"}>
                  {isMobile ? "🎬 Scheda" : <><span>🎬</span> <span>Scheda Film</span></>}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="prodotto" className={isMobile ? "py-2 px-3" : "d-flex align-items-center gap-2"}>
                  {isMobile ? "📦 Prodotto" : <><span>📦</span> <span>Dettagli Prodotto</span></>}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="prezzi" className={isMobile ? "py-2 px-3" : "d-flex align-items-center gap-2"}>
                  {isMobile ? "💰 Prezzi" : <><span>💰</span> <span>Prezzi e Magazzino</span></>}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="catalogo" className={isMobile ? "py-2 px-3" : "d-flex align-items-center gap-2"}>
                  {isMobile ? "📚 Catalogo" : <><span>📚</span> <span>Catalogo e Web</span></>}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body className="p-4">
            <Tab.Content>
              {/* TAB SCHEDA FILM */}
              <Tab.Pane eventKey="scheda" className="mt-3">
                <h5 className="text-primary mb-4">🎬 Informazioni Film</h5>
                <Row>
                  <Col md={8}>
                    <div className="mb-3">
                      <strong className="text-muted">Titolo:</strong>
                      <p className="mb-0 fs-5">{film.titolo || 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">Anno:</strong>
                      <p className="mb-0">{film.anno || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Regista:</strong>
                      <p className="mb-0">{film.regista || 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Genere:</strong>
                      <div className="d-flex align-items-center gap-2">
                        <p className="mb-0">{film.genere || 'N/D'}</p>
                        {getGenreImagePath(film.genere) && (
                          <img 
                            src={getGenreImagePath(film.genere)} 
                            alt={`Genere ${film.genere}`}
                            style={{ height: '30px', objectFit: 'contain' }}
                            title={film.genere}
                          />
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Durata:</strong>
                      <p className="mb-0">{film.durata ? `${film.durata} min` : 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Casa di Produzione:</strong>
                      <p className="mb-0">{film.casa_di_produzione || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mb-3">
                      <strong className="text-muted">Casa di Distribuzione:</strong>
                      <p className="mb-0">{film.casa_di_distribuzione || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <hr />
                <div className="mb-3">
                  <strong className="text-muted">Attori:</strong>
                  <p className="mb-0">{film.attori || 'N/D'}</p>
                </div>
                <div className="mb-3">
                  <strong className="text-muted">Trama:</strong>
                  <p className="mb-0">{film.trama || 'N/D'}</p>
                </div>
              </Tab.Pane>

              {/* TAB DETTAGLI PRODOTTO */}
              <Tab.Pane eventKey="prodotto" className="mt-3">
                <h5 className="text-primary mb-4">📦 Dettagli Prodotto</h5>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Categoria:</strong>
                      <p className="mb-0">{film.categoria || 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Supporto:</strong>
                      <p className="mb-0">{film.supporto || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">SKU:</strong>
                      <p className="mb-0 font-monospace">{film.sku || 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">Barcode:</strong>
                      <p className="mb-0 font-monospace">{film.barcode || 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">Barcode IBS:</strong>
                      <p className="mb-0 font-monospace">{film.barcode_ibs || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mb-3">
                      <strong className="text-muted">Ubicazione:</strong>
                      <p className="mb-0">{film.ubicazione || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
              </Tab.Pane>

              {/* TAB PREZZI E MAGAZZINO */}
              <Tab.Pane eventKey="prezzi" className="mt-3">
                <h5 className="text-primary mb-4">💰 Prezzi e Magazzino</h5>
                <Row>
                  <Col md={3}>
                    <div className="mb-3">
                      <strong className="text-muted">Prezzo Negozio:</strong>
                      <p className="mb-0 fs-5 text-success">{film.prezzo_negozio ? `€ ${film.prezzo_negozio.toFixed(2)}` : 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <strong className="text-muted">Prezzo IBS:</strong>
                      <p className="mb-0 fs-5 text-info">{film.prezzo_ibs ? `€ ${film.prezzo_ibs.toFixed(2)}` : 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <strong className="text-muted">Costo Acquisto:</strong>
                      <p className="mb-0 fs-5 text-danger">{film.costo_acquisto ? `€ ${film.costo_acquisto.toFixed(2)}` : 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <strong className="text-muted">IVA:</strong>
                      <p className="mb-0">{film.iva ? `${film.iva}%` : 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Condizione:</strong>
                      <p className="mb-0">{film.condizione || 'N/D'}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <strong className="text-muted">Quantità:</strong>
                      <p className="mb-0 fs-5">{film.quantita !== null && film.quantita !== undefined ? film.quantita : 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mb-3">
                      <strong className="text-muted">Fornitore:</strong>
                      <p className="mb-0">{film.fornitore?.denominazione || 'N/D'}</p>
                    </div>
                  </Col>
                </Row>
              </Tab.Pane>

              {/* TAB CATALOGO E WEB */}
              <Tab.Pane eventKey="catalogo" className="mt-3">
                <h5 className="text-primary mb-4">📚 Catalogo e Pubblicazione Web</h5>
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">Versione Noleggio:</strong>
                      <p className="mb-0">{film.versione_noleggio ? '✅ Sì' : '❌ No'}</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">Fuori Catalogo:</strong>
                      <p className="mb-0">{film.fuori_catalogo ? '✅ Sì' : '❌ No'}</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <strong className="text-muted">Pubblicato su IBS:</strong>
                      <p className="mb-0">{film.da_pubblicare_su_ibs ? '✅ Sì' : '❌ No'}</p>
                    </div>
                  </Col>
                </Row>
                <hr />
                <div className="mb-3">
                  <strong className="text-muted">Descrizione WEB:</strong>
                  <div className="mt-2 p-3 bg-light rounded" dangerouslySetInnerHTML={{ __html: film.descrizione_web || '<em class="text-muted">Nessuna descrizione disponibile</em>' }} />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Card>
      </Tab.Container>

    </Container>
  );
};

export default FilmDetail;